const MANAGER_FIELDS_FRAGMENT = `
fragment managerFields on User {
  id
  name
  email
  status
  resetPasswordSentAt
  isRemovable
  isMovable
  lastSignInAt
  generalManager
  checkoutManager
  binCount
  updatedAt
  role
  emailInboundInventoryApproval
  emailLowStockWarning
  emailOrderApprovalRequest
  emailReplenishmentPlanReminder
  emailLocationInventory
  enableReports
  divisions {
    id
    name
  }
  teams {
    id
    name
  }
}
`

const TECHNICIAN_FIELDS_FRAGMENT = `
fragment technicianFields on User {
  id
  name
  email
  status
  isRemovable
  isMovable
  lastSignInAt
  updatedAt
  checkoutManager
  binCount
  role
  emailInboundInventoryApproval
  emailLowStockWarning
  emailOrderApprovalRequest
  emailReplenishmentPlanReminder
  emailLocationInventory
  enableReports
  divisions {
    id
    name
  }
  teams {
    id
    name
  }
}
`

const PLANNER_FIELDS_FRAGMENT = `
fragment plannerFields on User {
  id
  name
  email
  status
  resetPasswordSentAt
  isRemovable
  isMovable
  lastSignInAt
  updatedAt
  role
  emailInboundInventoryApproval
  emailLowStockWarning
  emailOrderApprovalRequest
  emailReplenishmentPlanReminder
  enableReports
  teams {
    id
    name
  }
}
`

export const USERS_QUERY = `
${MANAGER_FIELDS_FRAGMENT}
${TECHNICIAN_FIELDS_FRAGMENT}
${PLANNER_FIELDS_FRAGMENT}

query FindUsers($branchId: Int!) {
  manager {
    account {
      id
    }

    currentBranch: branches(id: $branchId) {
      divisions {
        id
        name
      }
      teams {
        id
        name
      }
      technicians: technicians(status: ["active", "pending"]) {
        ...technicianFields
      }
      generalManagers: managers(generalManager: true, status: ["active", "pending"]) {
        ...managerFields
      }
      checkoutManagers: checkoutUsers(status: ["active", "pending"]) {
        ...managerFields
      }
      managers: managers(status: ["active", "pending"]) {
        ...managerFields
      }
      planners: planners(status: ["active", "pending"]) {
        ...plannerFields
      }
      inactive: users(status: ["inactive"]) {
        ...managerFields
      }
    }
  }
}
`

export const INTERNAL_USERS_QUERY = `
${MANAGER_FIELDS_FRAGMENT}
${TECHNICIAN_FIELDS_FRAGMENT}
${PLANNER_FIELDS_FRAGMENT}

query FindUsers($branchId: Int!, $accountId: Int!) {
  internal {
    accounts(id: $accountId) {
      nodes {
        id

        currentBranch: branches(id: $branchId) {
          divisions {
            id
            name
          }
          teams {
            id
            name
          }
          technicians: technicians(status: ["active", "pending"]) {
            ...technicianFields
          }
          generalManagers: managers(generalManager: true, status: ["active", "pending"]) {
            ...managerFields
          }
          checkoutManagers: checkoutUsers(status: ["active", "pending"]) {
            ...managerFields
          }
          managers: managers(status: ["active", "pending"]) {
            ...managerFields
          }
          planners: planners(status: ["active", "pending"]) {
            ...plannerFields
          }
          inactive: users(status: ["inactive"]) {
            ...managerFields
          }
        }
      }
    }
  }
}
`

export const MOVE_TECHNICIAN_QUERY = `
mutation TechnicianMove($id: Int!, $branchIds: [Int!]!) {
  technicianMove(id: $id, branchIds: $branchIds) {
    errors
  }
}
`

export const MOVE_USER_QUERY = `
mutation UserMove($id: Int!, $branchIds: [Int!]!) {
  userMove(id: $id, branchIds: $branchIds) {
    errors
  }
}
`

export const UPDATE_MANAGER_QUERY = `
${MANAGER_FIELDS_FRAGMENT}

mutation ManagerUpdate($id: Int!, $attributes: ManagerAttributes!, $branchId: Int) {
  managerUpdate(id: $id, attributes: $attributes, branchId: $branchId) {
    errors
    result {
      ...managerFields
      teams {
        id
        name
      }
    }
  }
}
`

export const USER_CHECKOUTS_QUERY = `
query FindCheckouts($branchId: Int!, $userId: Int!, $status: CheckoutStatusesEnum!) {
  manager {
    currentBranch: branches(id: $branchId) {
      technicians: technicians(id: $userId) {
        checkouts(status: $status, branchId: $branchId) {
          status
          name
          asap
          cost
          createdAt
          updatedAt
          id
          totalItems
          totalUnits
        }
      }
      managers: managers(id: $userId) {
        checkouts(status: $status, branchId: $branchId) {
          status
          name
          asap
          cost
          createdAt
          updatedAt
          id
          totalItems
          totalUnits
        }
      }
    }
  }
}
`

export const INTERNAL_USER_CHECKOUTS_QUERY = `
query FindCheckouts($branchId: Int!, $accountId: Int!, $userId: Int!, $status: CheckoutStatusesEnum!) {
  internal {
    accounts(id: $accountId) {
      nodes {
        id

        currentBranch: branches(id: $branchId) {
          technicians: technicians(id: $userId) {
            checkouts(status: $status, branchId: $branchId) {
              status
              name
              asap
              cost
              createdAt
              updatedAt
              id
              totalItems
              totalUnits
            }
          }
          managers: managers(id: $userId) {
            checkouts(status: $status, branchId: $branchId) {
              status
              name
              asap
              cost
              createdAt
              updatedAt
              id
              totalItems
              totalUnits
            }
          }
        }
      }
    }
  }
}
`
